"use client";

import * as React from "react";

import { createSVGIcon } from "../../util";

export const SmallBatch = createSVGIcon(
  <>
    <title>Small Batch</title>
    <path
      d="M11.8778 22.4549L2.72943 11.9523L6.61675 7.71915H17.5724L21.031 11.9523L11.8778 22.4549Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.74891 11.9523H21.0164"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8583 22.3526L8.28274 12.1374C8.22429 11.9621 8.22429 11.7721 8.29248 11.6016L9.71491 7.97246"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9119 22.4647L15.9697 12.1277C16.033 11.9718 16.0379 11.7965 15.9941 11.6357L14.8688 7.72404"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.74965 2.65784L6.71905 4.77201"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8827 3.53956V1.14286"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.571428 6.55003L2.62713 7.29535"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0108 2.65784L17.0365 4.77201"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.189 6.55003L21.1284 7.29535"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "SmallBatch",
  { viewBox: "0 0 24 24", titleAccess: "SmallBatch", fill: "none" }
);
